import { render, staticRenderFns } from "./LeagueView.vue?vue&type=template&id=5d2568bc&"
import script from "./LeagueView.vue?vue&type=script&lang=js&"
export * from "./LeagueView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports